import * as PIXI from "pixi.js";
import Main from "../Main";
import BoxLayer from "../layers/BoxLayer";
import TextureManager from "../managers/TextureManager";

const BOX_INSIDE_PATH = "./images/scene/box_inside_mask.png";//751x751


export default class BoxInsideMask extends PIXI.Sprite {
  Main = Main.getInstance();
  BoxLayer = BoxLayer.getInstance();

  constructor() {
    super();
    this.addBounds();
    this.addTexture();
    this.addToLayer();
  }

  addBounds() {
    const dim = this.Main.getDim();
    this.x = dim.width / 2;
    this.y = dim.height / 2;
    this.width = 561;
    this.height = 510;
    this.anchor.set(.5);
  }
  addTexture() {
    const texture = TextureManager.getTexture(BOX_INSIDE_PATH);
    this.texture = texture;
  }

  addToLayer() {
    this.BoxLayer.addChild(this);
    this.BoxLayer.mask = this;
  }
}